import React from 'react';
import { MerchantShell } from '../components/MerchantShell';
import { useGetDashboardQuery } from '../api';
import { LoadingState, ErrorState, EmptyState } from '../components/CabinetPrimitives';

export const MerchantOverviewPage: React.FC = () => {
  const { data, isLoading, isError, refetch } = useGetDashboardQuery(undefined, { refetchOnMountOrArgChange: true });
  return <MerchantShell title="Обзор" subtitle="Контроль операций, взаиморасчётов и активных валют" showDashboard>
    <section className="merchant-workspace">
      <div className="merchant-workspace-head"><div><h2>Интеграция</h2><p>Основные параметры подключения мерчанта.</p></div></div>
      {isLoading && <LoadingState />}
      {isError && <ErrorState onRetry={refetch} />}
      {data && <div className="merchant-overview-grid">
        <article><span>Логин мерчанта</span><strong>{data.merchant.username}</strong></article>
        <article><span>Callback URL</span><strong>{data.merchant.callback_url || 'Не настроен'}</strong></article>
        <article><span>Подключено валют</span><strong>{data.currency_rates.length}</strong></article>
        <article><span>Выплаты за всё время</span><strong>{data.activity.withdrawals_total}</strong></article>
      </div>}
      {!isLoading && !isError && !data && <EmptyState label="Нет данных для отображения." />}
    </section>
  </MerchantShell>;
};
